import { Typography, Chip, Paper, Checkbox } from "@mui/material";
import { Draggable } from "@hello-pangea/dnd";
import type { JobCardInfo } from "./types";
import { makeJobDraggableId } from "./draggableId.helpers";

export function JobCard({
	job,
	index,
	isSelected,
	onToggleSelect,
	multiDragCount = 0,
}: {
	job: JobCardInfo;
	index: number;
	isSelected?: boolean;
	onToggleSelect?: (draggableId: string, shiftKey: boolean) => void;
	multiDragCount?: number;
}) {
	const draggableId = makeJobDraggableId(job.jobId);

	return (
		<Draggable draggableId={draggableId} index={index}>
			{(provided, snapshot) => {
				const isDimmed = !snapshot.isDragging && multiDragCount > 0;
				const showBadge = snapshot.isDragging && multiDragCount > 1;

				return (
					<Paper
						ref={provided.innerRef}
						{...provided.draggableProps}
						{...provided.dragHandleProps}
						elevation={snapshot.isDragging ? 4 : 1}
						onClick={(e) => onToggleSelect?.(draggableId, e.shiftKey)}
						sx={{
							p: 1,
							mb: 0.5,
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
							position: "relative",
							bgcolor: snapshot.isDragging ? "action.hover" : isSelected ? "primary.50" : "background.paper",
							cursor: "grab",
							"&:active": { cursor: "grabbing" },
							userSelect: "none",
							opacity: isDimmed ? 0.4 : 1,
							transition: "opacity 0.15s",
						}}
					>
						{showBadge && (
							<Chip
								label={multiDragCount}
								color="primary"
								size="small"
								sx={{
									position: "absolute",
									top: -8,
									right: -8,
									height: 22,
									minWidth: 22,
									fontWeight: 700,
									fontSize: "0.75rem",
									zIndex: 1,
								}}
							/>
						)}
						<Checkbox size="small" checked={!!isSelected} tabIndex={-1} disableRipple sx={{ p: 0, mr: 0.5 }} />
						<Typography variant="body2" noWrap sx={{ flex: 1, mr: 1, fontWeight: 600 }}>
							{job.fieldName || "Unnamed Field"}
						</Typography>
						<Typography variant="caption" color="text.secondary" noWrap sx={{ maxWidth: 100 }}>
							{job.growerName}
							{/* {job.farmName ? ` / ${job.farmName}` : ""} */}
						</Typography>
					</Paper>
				);
			}}
		</Draggable>
	);
}
